import { Component, Input, Output, EventEmitter, Optional } from "@angular/core";
import { ControlContainer, FormGroup } from "@angular/forms";


@Component({
  selector: "popper-comment",
  templateUrl: "./popper-comment.component.html",
  styleUrls: ["./popper-comment.component.scss"],
})
export class PopperCommentComponent {

  @Input() public formGroup: FormGroup;
  @Input() public for: string;
  @Input() public readonly: boolean = false;

  constructor(@Optional() private _controlContainer: ControlContainer) {}

  ngOnInit(): void {
    if (!this.formGroup && this._controlContainer && this._controlContainer.control instanceof FormGroup) {
      this.formGroup = <FormGroup>this._controlContainer.control;
    }
  }

  public get hasValue(): boolean {
    return this.formGroup.get(this.for)?.value;
  }

  public clearComment() {
    this.formGroup.get(this.for).setValue(null);
  }

}


